import { Paragraph2 } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

import { StoreCardSection } from "./StoreCardSection"
import { useReviewReasonTranslation } from "@/hooks/useReviewReasonTranslation"
import { ReviewReason } from "@/libs/bounce/bounceSdk.types.gen"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import HeartIcon from "@bounce/assets/icons/Heart.svg"

type StoreCardReviewReasonsSectionProps = Pick<NearbyStorageSpot, "reviewSummary">

const MAX_REVIEW_REASONS = 3
const ALLOWED_REVIEW_REASONS = [
  ReviewReason.AdditionalSecurity,
  ReviewReason.ConvenientLocation,
  ReviewReason.EasyCico,
  ReviewReason.FastService,
  ReviewReason.FriendlyStaff,
  ReviewReason.SafeLocation,
  ReviewReason.GreatValue,
]

export const StoreCardReviewReasonsSection = ({ reviewSummary }: StoreCardReviewReasonsSectionProps) => {
  const { t } = useTranslation()
  const { translate } = useReviewReasonTranslation()

  if (!reviewSummary.reasonCounts) {
    return null
  }

  const reasons = reviewSummary.reasonCounts
    .filter(({ reason }) => ALLOWED_REVIEW_REASONS.includes(reason))
    .sort((a, b) => b.count - a.count)
    .slice(0, MAX_REVIEW_REASONS)
    .map(({ reason }) => translate(reason))

  if (!reasons.length) {
    return null
  }

  const [reasonOne, reasonTwo, reasonThree] = reasons

  return (
    <StoreCardSection icon={HeartIcon}>
      <Paragraph2 className="!text-[0.875rem]">
        {t(
          "cmp.storeCard.reviewReasonsLabel",
          "Customers love the {reasonCount, select, 1 {{reasonOne}} 2 {{reasonOne}, and {reasonTwo}} other {{reasonOne}, {reasonTwo}, and {reasonThree}}}",
          {
            reasonCount: reasons.length,
            reasonOne,
            reasonTwo,
            reasonThree,
          },
        )}
      </Paragraph2>
    </StoreCardSection>
  )
}
